import $ from 'jquery';

const printButton = (buttonEl) => {
    $(buttonEl).on('click', (e) => {
        window.print();
    });
};

export default printButton;
